import React, { useEffect, useState } from 'react'
import { Helmet } from '@dr.pogodin/react-helmet'
import { Stack, Box, Typography, Divider, Card as MuiCard, CardContent } from '@mui/material'
import styled from '@emotion/styled'
import { spacing } from '@mui/system'

import { MCIssuesGrid } from './MCIssuesGrid'
import FLIssuesGrid from './FLIssuesGrid/FLIssuesGrid'
import { MCIssueEntity } from 'types/MCEntity'
import IssueApi from '../../../api/IssueApi'

const Card = styled(MuiCard)(spacing)

const issueApi = new IssueApi()

function AdminIssuesReview() {
    const [selectedMCIssue, setSelectedMCIssue] = useState<MCIssueEntity | null>(null)
    const [mcIssues, setMCIssues] = useState<MCIssueEntity[]>([])

    useEffect(() => {
        async function fetchMCIssues() {
            const mcIssues = await issueApi.findMcIssues()
            const filteredMcIssues = mcIssues.filter((mcIssue) => !mcIssue.archivedAt)
            setMCIssues(filteredMcIssues)
        }
        void fetchMCIssues()
    }, [])

    const onArchiveMcIssue = async (mcIssueToArchive: MCIssueEntity) => {
        await issueApi.archiveMcIssue(mcIssueToArchive.id)

        const filteredMcIssues = mcIssues.filter((mcIssue) => mcIssue.id !== mcIssueToArchive.id)

        setMCIssues(filteredMcIssues)
        setSelectedMCIssue(null)
    }

    const markAsConvertible = async (mcIssueToMarkAsConvertible: MCIssueEntity) => {
        await issueApi.archiveMcIssue(mcIssueToMarkAsConvertible.id, true)

        const filteredMcIssues = mcIssues.filter((mcIssue) => mcIssue.id !== mcIssueToMarkAsConvertible.id)

        setMCIssues(filteredMcIssues)
        setSelectedMCIssue(null)
    }

    return (
        <React.Fragment>
            <Helmet title='Avstämning' />
            <Typography variant='h3' gutterBottom display='block'>
                Avstämning
            </Typography>

            <Divider sx={{ marginY: 6 }} />

            <Card mb={6}>
                <CardContent>
                    <Stack spacing={2} direction='row'>
                        <Box flex={1}>
                            <MCIssuesGrid setSelectedMCIssue={setSelectedMCIssue} mcIssues={mcIssues} />
                        </Box>
                        <Box flex={1}>
                            <FLIssuesGrid
                                selectedMCIssue={selectedMCIssue}
                                setMCIssues={setMCIssues}
                                onArchiveMcIssue={onArchiveMcIssue}
                                markAsConvertible={markAsConvertible}
                            />
                        </Box>
                    </Stack>
                </CardContent>
            </Card>
        </React.Fragment>
    )
}

export default AdminIssuesReview
